import {Box, styled} from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React from 'react';
import PropTypes from 'prop-types';

export const SettingsSection = styled(Box)(({theme}) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
}));

const SettingsSectionBase = ({header, subHeader, headerIcon, children}) => (
    <Stack
        direction="column"
        gap={2}
    >
        <Box>
            <Stack flexDirection="row" gap={1} alignItems="center">
                {headerIcon}
                <Typography variant="h6" fontWeight="bold">
                    {header}
                </Typography>
            </Stack>
            {subHeader && (
                <Typography variant="subtitle2" color="text.secondary">
                    {subHeader}
                </Typography>
            )}
        </Box>
        {children}
    </Stack>
);

SettingsSectionBase.propTypes = {
    header: PropTypes.node.isRequired,
    headerIcon: PropTypes.node,
    subHeader: PropTypes.node,
    children: PropTypes.node,
};

export default SettingsSectionBase;